module.exports = __webpack_public_path__ + "static/img/gangzhonglv.dfe48df4.png";